























import { Vue, Component, Prop } from 'vue-property-decorator';
import ISubmissionAnswer from '@/types/ISubmissionAnswer';
import IQuizError from '@/types/IQuizError';
import messageBus from '../../utils/MessageBus';

@Component
export default class TextInput extends Vue {
  disabled: boolean = true;
  $refs!: {
    inputElement: HTMLInputElement,
  };

  @Prop() id!: string;
  @Prop() value!: string;
  @Prop() error!: IQuizError;

  get inputVal(): string {
    return this.value;
  }

  set inputVal(v: string) {
    this.$emit('input', v);
  }

  // handle extra keyboard input
  handleKeyInput(keyValue: string): void {
    const subElem = this.$refs.inputElement;
    subElem.focus();

    let newValue = this.inputVal;

    // find where the cursor or selection currently is, insert/replace,
    // and move cursor to after insertion
    if (subElem.selectionStart && subElem.selectionStart >= 0) {
      const startPos: number = subElem.selectionStart;
      const endPos: number = subElem.selectionEnd || startPos;
      newValue = `${subElem.value.substring(0, startPos)}${keyValue}${subElem.value.substring(
        endPos,
        subElem.value.length,
      )}`;

      const setCursorPosition = (el: HTMLInputElement, pos: number) => {
        // nextTick() gets the DOM in place, and then run this after to keep the cursor in place
        setTimeout(() => {
          el.focus();
          el.setSelectionRange(pos, pos);
        }, 1);
      };

      subElem.selectionStart = startPos + keyValue.length;
      this.$nextTick(() => setCursorPosition(subElem, startPos + keyValue.length));
    } else {
      newValue += keyValue;
    }

    this.$emit('input', newValue);
  }

  highlightError(start?: number, stop?: number) {
    const subElem: HTMLInputElement = this.$refs.inputElement;
    subElem.focus();

    // select the incorrect part of the user submission
    if (typeof start === 'undefined') {
      subElem.selectionStart = subElem.selectionEnd;
    } else {
      subElem.setSelectionRange(start, stop || start);
    }

    // briefly add failure styling after submission
    subElem.classList.add('failure');
    setTimeout(() => {
      subElem.classList.remove('failure');
    }, 900);

    this.$nextTick(() => subElem.focus());
  }

  onEnableInput(isEnabled: boolean) {
    this.disabled = !isEnabled;
  }

  onAudioPlaying(isPlaying: boolean) {
    if (!isPlaying) {
      setTimeout(() => this.$refs.inputElement.focus(), 100);
    }
  }

  onAnswerSubmitted(submitted: ISubmissionAnswer) {
    if (submitted.status === 'failure') {
      if (submitted.error) {
        // noinspection TypeScriptUnresolvedVariable
        this.highlightError(this.error.range.start, this.error.range.stop);
      } else {
        this.highlightError();
      }
    }
  }

  // noinspection JSUnusedGlobalSymbols
  mounted() {
    // handler for extra keyboard input
    messageBus.$on('extraKeyInput', this.handleKeyInput);

    // handler to enable/disable input
    messageBus.$on('enableInput', this.onEnableInput);

    // set focus after audio play finishes
    messageBus.$on('audioPlaying', this.onAudioPlaying);

    // highlight errors on submission
    messageBus.$on('answerSubmitted', this.onAnswerSubmitted);
  }

  // noinspection JSUnusedGlobalSymbols
  beforeDestroy() {
    messageBus.$off('extraKeyInput', this.handleKeyInput);
    messageBus.$off('enableInput', this.onEnableInput);
    messageBus.$off('audioPlaying', this.onAudioPlaying);
    messageBus.$off('answerSubmitted', this.onAnswerSubmitted);
  }
}
